import { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react';

import { Wrapper } from './NumberedSteps.parts';
import { Step, type NumberedStepVariant, type StepProps } from './Step';

export type NumberedStepsProps = {
	children: ReactNode;
	variant?: NumberedStepVariant;
};

export function NumberedSteps(props: NumberedStepsProps & { className?: string }) {
	const children = Children.toArray(props.children);

	return (
		<Wrapper className={props.className} variant={props.variant}>
			{children.map((child, index) => {
				if (isValidElement(child) && child.type === Step) {
					return cloneElement(child as ReactElement<StepProps>, {
						key: child.key ?? index,
						number: index + 1,
						variant: props.variant,
					});
				}

				return (
					<Step key={index} number={index + 1} variant={props.variant}>
						{child}
					</Step>
				);
			})}
		</Wrapper>
	);
}
